import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleTransmissionTypeScreen from "../../../container/Vehicles/VehicleTransmissionTypeScreen";
import CreateVehicleTransmissionType from "../../../container/Vehicles/VehicleTransmissionTypeScreen/CreateVehicleTransmissionType";

const VehicleTransmissionTypeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_TRANSMISSIONTYPE.HOME}
          element={<VehicleTransmissionTypeScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_TRANSMISSIONTYPE.CREATE}
          element={<CreateVehicleTransmissionType />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_TRANSMISSIONTYPE.EDIT}
          element={<CreateVehicleTransmissionType isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleTransmissionTypeRoutes;
